export const BUSINESS_LANDINGS_SETTINGS_QUERY_KEY = 'businessLandings'
export const BUSINESS_ANONYMOUSLY_LANDINGS_SETTINGS_QUERY_KEY = 'businessLandingsView'
export const BUSINESS_LANDINGS_PATHS_QUERY_KEY = 'businessLandingsPaths'
